import isDevelopment from './isDevelopment'
import isStaging from './isStaging'

export default () => {
  if (isDevelopment) {
    return 'development'
  }
  if (isStaging) {
    return 'staging'
  }
  return 'production'
}
